import React from "react";
import FileUploadIcon from "material-ui/svg-icons/file/file-upload";
import IconButton from "material-ui/IconButton";
import { csv2json } from "json-2-csv";
import PropTypes from "prop-types";
import { NotificationManager } from "react-notifications";

import csv from 'csvtojson';

import "./FileUploader.css";

const arrayToJson = (arrays) => {
  let keys = arrays[0];
  let values = arrays.slice(1);

  return values.map(array => {
    let object = {};

    keys.forEach((key, i) => object[key] = array[i]);

    return object;
  });
};

const FileUploader = ({
  fileInputRef,
  entity,
  onUploadFile,
  userId,
  options,
  prepareData
}) => {
  const onUpload = event => {
    try {
      const file = fileInputRef.current.files[0];
      if (!file.type.includes("csv") && !file.name.includes("csv")) {
        NotificationManager.error("File not supported", "Error");
        fileInputRef.current.value = "";
        return;
      }

      const reader = new FileReader();

      reader.onloadend = e => {
        let text = e.srcElement.result;

        csv({
          output: "csv",
          noheader:true,
        })
          .fromString(text)
          .then((json)=>{
            if (json) {
              let data = arrayToJson(json);

              if (prepareData) {
                data = prepareData(json);
              }

              onUploadFile(userId, data).then(
                () => {
                  NotificationManager.success("Success", `${file.name} added`);
                  fileInputRef.current.value = "";
                },
                () => {
                  NotificationManager.error("Error", "File not added");
                  fileInputRef.current.value = "";
                }
              );
            } else {
              NotificationManager.error("Error", "File error");
              fileInputRef.current.value = "";
            }
          });
      };

      reader.readAsText(file); //blob to string
    } catch (e) {
      NotificationManager.error("Error", "Error");
      fileInputRef.current.value = "";
    }
  };

  const onChoseFile = () => {
    fileInputRef.current.click();
  };

  return (
    <React.Fragment>
      <input
        className="upload-file-input"
        ref={fileInputRef}
        onChange={onUpload}
        accept="text/csv"
        type="file"
      />
      <IconButton
        tooltipPosition="bottom-center"
        tooltip={`Upload ${entity} from file`}
        onClick={onChoseFile}
        style={{
          position: "fixed",
          top: 10,
          right: 250,
          zIndex: 1300
        }}
      >
        <div className="wrap-upload-file">
          <FileUploadIcon
            color="#6da92e"
            style={{ width: "50px", height: "50px" }}
          />
        </div>
      </IconButton>
    </React.Fragment>
  );
};

FileUploader.propTypes = {
  fileInputRef: PropTypes.string,
  entity: PropTypes.string,
  onUploadFile: PropTypes.func,
  userId: PropTypes.string,
  options: PropTypes.object,
  prepareData: PropTypes.func
};

FileUploader.defaultProps = {
  options: null
};

export default FileUploader;
